import { ApqModel } from "../../domain/ApqModel";
import { SectionProps } from "./SectionProps";
import { Select } from "@ofqual/portal-components/components/Select";
import { Controller } from "react-hook-form";
import { Grid } from "@material-ui/core";
import { cachedApqSourceTypeService } from "../../services";
import { useLookup } from "@ofqual/portal-core/core/hooks";
import { Error } from "../common/Error";

export const ContactTypeSection: React.FC<SectionProps<ApqModel>> = ({
  control,
  errors,
  disabled,
  user: { token },
  item,
  clearErrors,
}) => {
  const [apqSourceTypeLookups] = useLookup({
    service: cachedApqSourceTypeService,
    id: "id",
    label: "value",
  });

  return (
    <Grid item xs={12}>
      <Controller
        control={control}
        name="contactTypeId"
        rules={{ required: true }}
        render={({ onChange, ...props }) => (
          <Select
            label="Contact Type"
            disabled={disabled}
            datatest="contactTypeId-field"
            required
            onChange={(e) => {
              if (e.target.value !== null) {
                clearErrors("contactTypeId");
              }
              onChange(e);
            }}
            {...props}
          >
            {apqSourceTypeLookups}
          </Select>
        )}
      />
      {errors.contactTypeId?.type === "required" && (
        <Error data-test="contactType-validation">This field is required</Error>
      )}
    </Grid>
  );
};
